import { render, staticRenderFns } from "./DelegationModal.vue?vue&type=template&id=5819e5e5&"
import script from "./DelegationModal.vue?vue&type=script&lang=js&"
export * from "./DelegationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5819e5e5')) {
      api.createRecord('5819e5e5', component.options)
    } else {
      api.reload('5819e5e5', component.options)
    }
    module.hot.accept("./DelegationModal.vue?vue&type=template&id=5819e5e5&", function () {
      api.rerender('5819e5e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/DelegationModal.vue
// module id = 639
// module chunks = 0